import equals from "fast-deep-equal"

/**
 * Performs a deep equality check on two objects
 */
export const isDeepEqual = (a: any, b: any) => {
	return equals(a, b)
}

export function isDefined<T>(value: T | undefined): value is T {
	return value !== undefined
}
